<template>
  <AddPaiement />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumbs from "@/layout/BreadCrumbs.vue";
import AddPaiement from "@/components/GesCom/Paiement/AddPaiement.vue";

export default defineComponent({
  name: "AddPaiementPage",
  components: {
    BreadCrumbs,
    AddPaiement,
  },
});
</script>
